import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import Button from 'eventbrite_design_system/button/Button';
import {TYPE_LINK} from 'eventbrite_design_system/button/constants';


export default class SeeMoreButton extends PureComponent {
    static propTypes = {
        /**
         * Title of parent bucket
         */
        title: PropTypes.string.isRequired,
        /**
         * The url the user should be directed to
         */
        linkUrl: PropTypes.string,
        /**
         * The text the button should display
         */
        seeMoreText: PropTypes.string,
        /**
         * Tracking callback for button clicks
         */
        trackClick: PropTypes.func,
        /**
         * String representing user action to send to GA
         */
        gaAction: PropTypes.string,
    };

    render() {
        const {
            title,
            linkUrl,
            seeMoreText,
            trackClick,
            gaAction,
        } = this.props;
        const ariaLabel = seeMoreText ? seeMoreText : gettext('See more %(title)s', {title});
        const buttonLabel = seeMoreText ? seeMoreText : gettext('See more');

        let component = null;

        if (linkUrl) {
            component = (
                <Button
                    type={TYPE_LINK}
                    href={linkUrl}
                    onClick={trackClick.bind(null, {url: linkUrl}, gaAction)}
                    aria-label={ariaLabel}
                >
                    {buttonLabel}
                </Button>
            );
        }

        return component;
    }
}
